/*
 * Module for the Estimates Index page (Estimate History)
*/
rs.module("content/benefits/estimates/index",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            var estimateHistoryList = $.js(jsSelectors.estimateHistoryList);
            var listSkeleton = $.js(jsSelectors.listSkeleton);

            $.js(jsSelectors.fundPicker, { required: false }).change(function () {

                // Show list skeleton while we load content.
                listSkeleton.show();
                estimateHistoryList.hide();

                var values = $(this).val().split("|");

                $.get(
                    backendUrls.retrieveEstimates,
                    {
                        fundKey: values[0],
                        accountKey: values[1]
                    })
                    .done(function (html) {
                        estimateHistoryList.html(html);
                    })
                    .always(function () {
                        listSkeleton.hide();
                        estimateHistoryList.show();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);